"use client";

import { useState } from "react";
import { Copy, Check } from "lucide-react";

type CopyPromptButtonProps = {
  text: string;
  copyLabel?: string;
  copiedLabel?: string;
};

export default function CopyPromptButton({
  text,
  copyLabel = "Copy prompt",
  copiedLabel = "Copied!",
}: CopyPromptButtonProps) {
  const [copied, setCopied] = useState(false);
  const currentLabel = copied ? copiedLabel : copyLabel;

  const handleCopy = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      className="p-2 rounded-lg bg-white/80 border border-black/[0.06] text-black/40 hover:text-black/70 hover:bg-white transition-colors shrink-0"
      aria-label={currentLabel}
      title={currentLabel}
    >
      {copied ? (
        <Check className="w-4 h-4 text-emerald-500" />
      ) : (
        <Copy className="w-4 h-4" />
      )}
    </button>
  );
}
